import { Button, message } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Tooltip } from "common/components/tooltip/tooltip";
import Candidate from "../../../../../redux/models/candidate";
import Client from "../../../../../redux/models/client";
import { updateCandidateList } from "../../../../../redux/slices/candidateSlice";
import { AddCandidateModal } from "./addCandidateModal";
import styles from "../../clientsJob.module.scss";

export const AddCandidateButton = ({
  disabled,
  displayAssignedTooltip = false,
  getStatusBreakdown,
  getCandidateUdf,
  refreshTable,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const res = await Candidate.create(values);

      if (values.cvFile) {
        try {
          await Client.createCvAttachment(
            res.id,
            values.cvFile,
          );
        } catch (err) {
          console.error(err);
          message.warning("Candidate created but CV upload failed.");
        }
      }

      setOpen(false);
      dispatch(updateCandidateList(res));
      refreshTable()
      getStatusBreakdown();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip
        title={
          displayAssignedTooltip
            ? "You can not add a candidate to this job because you are not assigned to it."
            : null
        }
      >
        <span>
          <Button
            type="primary"
            onClick={() => setOpen(true)}
            className={`${styles.addCandidate} btn-add-candidate`}
            disabled={disabled || displayAssignedTooltip}
          >
            Add Candidate
          </Button>
        </span>
      </Tooltip>

      {open && (
        <AddCandidateModal
          open={open}
          loading={loading}
          onCancel={() => setOpen(false)}
          onFinish={onFinish}
          getCandidateUdf={getCandidateUdf}
        />
      )}
    </>
  );
};
